/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setSignature} from '../api'

export const useMutationSetSignature = createReactQueryMutationHook('setSignature', setSignature)
